/** PROTOTYPE Platform / Retention options -- the project-level inputs for a spread. */
import React from 'react';
import { CRC } from './moduleInputsData';
import { Label, NumberInput, Segmented, Toggle } from './protoAtoms';
import { PlatformOptions, RetentionOptions, RetentionTier } from './spreadProjectOptions';

const card: React.CSSProperties = { background: '#fff', border: `1px solid ${CRC.border}`, borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.04)', padding: 20 };
const heading: React.CSSProperties = { fontFamily: 'Funnel Sans', fontSize: 15, fontWeight: 600, color: CRC.blueprintBlue, marginBottom: 14 };
const note: React.CSSProperties = { marginTop: 12, fontSize: 11.5, color: CRC.heritageGrey };

interface Props {
  module: 'platform' | 'retention';
  platform: PlatformOptions;
  retention: RetentionOptions;
  setPlatform: (o: PlatformOptions) => void;
  setRetention: (o: RetentionOptions) => void;
}

export const SpreadProjectOptionsCard: React.FC<Props> = ({ module, platform, retention, setPlatform, setRetention }) => {
  if (module === 'platform') {
    return (
      <div style={card}>
        <div style={heading}>Platform options</div>
        <div style={{ display: 'flex', gap: 30, flexWrap: 'wrap', alignItems: 'flex-end' }}>
          <div><Label>Number of users</Label><div style={{ marginTop: 4 }}>
            <NumberInput value={platform.users} onChange={(v) => setPlatform({ ...platform, users: Math.max(0, v) })} width={100} />
          </div></div>
          <div><Label>Infrastructure</Label><div style={{ marginTop: 8 }}>
            <Toggle on={platform.infra} onClick={() => setPlatform({ ...platform, infra: !platform.infra })} label={platform.infra ? 'CRCE-hosted' : 'Customer-managed'} />
          </div></div>
          <div><Label>Support</Label><div style={{ marginTop: 8 }}>
            <Toggle on={platform.support} onClick={() => setPlatform({ ...platform, support: !platform.support })} label={platform.support ? 'Included' : 'Not included'} />
          </div></div>
        </div>
        <div style={note}>Infrastructure off = customer-managed cloud (no infra fee). Support off drops the support hours. Fee rates are in <strong>Edit overrides</strong>.</div>
      </div>
    );
  }
  return (
    <div style={card}>
      <div style={heading}>Retention options</div>
      <div style={{ display: 'flex', gap: 30, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <div><Label>Tier</Label><div style={{ marginTop: 5 }}>
          <Segmented value={retention.tier} onChange={(v) => setRetention({ ...retention, tier: v as RetentionTier })}
            options={[{ value: 'none', label: 'None' }, { value: 'cold', label: 'Cold' }, { value: 'warm', label: 'Warm' }]} />
        </div></div>
        {retention.tier !== 'none' && (
          <div><Label>Years</Label><div style={{ marginTop: 4 }}>
            <NumberInput value={retention.years} onChange={(v) => setRetention({ ...retention, years: Math.max(0, v) })} width={90} />
          </div></div>
        )}
      </div>
      <div style={note}>Post-handover data retention. Cold = archive, Warm = accessible. Annual fees are in <strong>Edit overrides</strong>.</div>
    </div>
  );
};
